import { stripBreakpointPrefix } from '@yola/atomic-css-generator';

const getResponsiveClassValue = ({ element, className, breakpoint }) => {
  const classAttr = element && element.getAttribute('class');
  if (!classAttr) return null;

  const token = classAttr.split(' ').find((t) => {
    if (!t) return false;

    const stripped = stripBreakpointPrefix(t);
    const matchesClass = stripped === className || stripped.startsWith(`${className}-`);

    if (breakpoint) {
      return t.startsWith(`${breakpoint}:`) && matchesClass;
    }

    return stripped === t && matchesClass;
  });

  if (!token) return null;

  const stripped = stripBreakpointPrefix(token);
  if (stripped === className) return null;

  const valuePart = stripped.slice(className.length + 1);
  return valuePart.replace(/[[\]]/g, '');
};

export default getResponsiveClassValue;
